export default __webpack_public_path__ + "static/media/score-bg.c319882e.png";